import {FRONT_URL, REACT_URL} from "@/common/config-local";

export default {
    setLeftNav(state, data){
        state.leftNav = data.map((item) => {
            if(item.href && !item.href.startsWith(REACT_URL)) {
                item.href = item.href.replace(FRONT_URL, '')
            }
            if(Array.isArray(item.items)){

                item.items = item.items.map(subItem => {
                    if(subItem.href && !subItem.href.startsWith(REACT_URL)) {
                        subItem.href = subItem.href.replace(FRONT_URL, '')
                    }
                    return subItem
                })
            }
            return item
        })
    },
    setLoading(state, loading) {
        state.loading = loading
    },
}